import api from './axios';
export const getNotificationCampaigns = () => api.get('/admin-notifications/campaigns');
export const createNotificationCampaign = (data) => api.post('/admin-notifications/campaigns', data);
export const getNotificationTemplates = () => api.get('/admin-notification-templates');
export const createNotificationTemplate = (data) => api.post('/admin-notification-templates', data);
export const updateNotificationTemplate = (id, data) => api.put(`/admin-notification-templates/${id}`, data);
